import React from 'react';
import JQBookings from './JQBookings';

function JQBookingsPage({ month }) {
  return (
    <div className="jq-page" style={{ maxWidth: 1200, margin: '0 auto' }}>
      <div style={{
        background: 'var(--rmc-white)',
        borderRadius: 20,
        padding: '2rem',
        border: '1px solid var(--rmc-line2)',
        boxShadow: '0 4px 12px -4px rgba(59, 91, 219, 0.2)'
      }}>
        <JQBookings month={month} />
      </div>
    </div>
  );
}

export default JQBookingsPage;
